import React from 'react';

import { PublicCodes as CommonPublicCodes } from '../common';

export const PublicCodes = () => {
  return <CommonPublicCodes />;
};
